/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.13 burger2.glb 
*/

import React, { useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import { RigidBody,MeshCollider } from '@react-three/rapier'

export default function Hamburger(props) {
    const group = useRef()
    const { nodes, materials, animations } = useGLTF('/burger2.glb')
    const { actions } = useAnimations(animations, group)

    nodes.Scene.scale.set(.25, 0.25, .25)

    return (
        <group ref={group} {...props} dispose={null} >
            <RigidBody
                gravityScale={2}
                colliders='cuboid'
            >
                <group name="Scene">

                    <mesh name="Cube" geometry={nodes.Cube.geometry} material={materials.bunMat} />

                    <mesh name="Cube001" geometry={nodes.Cube001.geometry} material={materials.meatMat} position={[0, 1.292, 0]} />
                    <mesh name="Plane" geometry={nodes.Plane.geometry} material={materials.cheeseMat} position={[-0.819, 4.726, -0.436]} scale={0.952} />
                    <mesh name="Cube002" geometry={nodes.Cube002.geometry} material={materials.bunMat} position={[0, 4.35, 0]} rotation={[-Math.PI, 0, 0]} />
                </group>
            </RigidBody>
        </group>
    )
}

useGLTF.preload('/burger2.glb')